import { OnDestroy, Directive, inject } from "@angular/core";
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { destroySyncfusionGrid, GridCleanupOptions } from './grid-cleanup.util';

type Disposable = { destroy?(): void; close?(): void; hide?(): void };
type ListenerRemover = () => void;

@Directive()
export abstract class DestroyableComponent implements OnDestroy {
  private eventListeners: Array<() => void> = [];

  protected addEventListener(
    target: EventTarget,      // For Dom element
    type: string,             // For Event types
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ): void {
    target.addEventListener(type, listener, options);
    this.eventListeners.push(() => {
      target.removeEventListener(type, listener, options);
    });
  }


  protected matDialog = inject(MatDialog, { optional: true });
  protected overlay = inject(OverlayContainer, { optional: true });
  protected bsModal = inject(BsModalService, { optional: true });

  private subs: Subscription[] = [];
  private timeouts: number[] = [];
  private intervals: number[] = [];
  private grids: Array<{ grid: GridComponent; opts?: GridCleanupOptions }> = [];
  private disposables: Disposable[] = [];

  protected sub<T extends Subscription>(s: T): T { this.subs.push(s); return s; }

  protected setTimeout(cb: () => void, ms: number) { const id = window.setTimeout(cb, ms); this.timeouts.push(id); return id; }
  protected setInterval(cb: () => void, ms: number) { const id = window.setInterval(cb, ms); this.intervals.push(id); return id; }
  protected registerGrid(grid: GridComponent, opts?: GridCleanupOptions) { this.grids.push({ grid, opts }); }
  protected trackDisposable<T extends Disposable>(x: T): T { this.disposables.push(x); return x; }



  ngOnDestroy(): void {

    this.matDialog?.closeAll?.();
    this.bsModal?.hide?.();

    for (const d of this.disposables) { try { d.close?.(); d.hide?.(); d.destroy?.(); } catch {} }

    for (const g of this.grids) { try { destroySyncfusionGrid(g.grid, g.opts); } catch {} }
    
    this.eventListeners.forEach(remove => { try { remove(); } catch {} });
    this.eventListeners = [];

    for (const s of this.subs) { try { s.unsubscribe(); } catch {} }
    this.subs = [];
    this.timeouts.forEach(clearTimeout); this.timeouts = [];
    this.intervals.forEach(clearInterval); this.intervals = [];
  }
}